import React, { useState } from 'react';

import PropTypes from 'prop-types';

import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { LEAN_SDK_SCREEN, LEAN_SELECT_BANK_SCREEN, LEAN_WAITING_SCREEN } from 'apps/auth/constants/ComponentNames';

import LeanSDK from './LeanSDK';
import LeanWaitingScreen from './LeanWaitingScreen';
import SelectBankScreen from './SelectBankScreen';

const LeanModal = ({ modalRef, href, bankId, leanPaymentIntendId, currentScreen = LEAN_SELECT_BANK_SCREEN }) => {
    const [screen, setScreen] = useState(currentScreen);

    const componentMap = {
        [LEAN_SELECT_BANK_SCREEN]: <SelectBankScreen modalRef={modalRef} primaryButtonOnClick={() => setScreen(LEAN_SDK_SCREEN)} />,
        [LEAN_SDK_SCREEN]: <LeanSDK modalRef={modalRef} setScreen={setScreen} href={href} bankId={bankId} leanPaymentIntendId={leanPaymentIntendId} />,
        [LEAN_WAITING_SCREEN]: <LeanWaitingScreen modalRef={modalRef} />,
    };
    return (
        <ModalComponent canCloseModal={false} isVerticalCentered={true} modalRef={modalRef} dataTestId="lean-modal">
            {componentMap[screen]}
        </ModalComponent>
    );
};
LeanModal.propTypes = {
    currentScreen: PropTypes.string,
    modalRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    href: PropTypes.string,
    leanPaymentIntendId: PropTypes.string,
    bankId: PropTypes.string,
};

export default LeanModal;
